import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DoubleArrow,
  LocalPrintshop,
  RestartAlt,
  Check,
  Clear,
} from '@mui/icons-material';
import { toaster } from 'evergreen-ui';
// import { popOver } from '../../assets/templates';
// import ToggleButton from '../ui/ToggleButton';
import Divider from '../ui/Divider';
import Pdf from '../../api/pdf';
import Users from '../../api/users';
import Client from '../../api/client';
import Categories from '../../api/categories';
import Quotations from '../../api/quotations';
import uploadImage from '../../api/uploadImage';
import { convertBase64, toInteger } from '../../utilities';
import { initialState } from '../../reducer';
import SelectFilter from '../ui/SelectFilter';

const SelectResultsView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
  setMaxView,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isPdfForClient, setIsPdfForClient] = useState(true);
  const [userData, setUserData] = useState({ isLoadingData: true });
  const [base64, setBase64] = useState({});
  const [selectValue, setSelectValue] = useState({});
  const [selectCategoryValue, setSelectCategoryValue] = useState({});
  const [machineData, setMachineData] = useState({ maxPower: 0, electricIntensity: 0 });
  const [clientData, setClientData] = useState({
    client: '',
    companyName: '',
    qty: '',
    validez: '',
    categoryName: '',
    isValidCategoryName: null,
    isValidClient: null,
  });
  const [count, setCount] = useState(1);
  const printCard = useRef(null);
  const userId = localStorage.getItem('id');

  const getMaxPower = () => {
    if (calculationsData?.design?.typeOfWork === 'cut-or-engrave') {
      return toInteger(calculationsData.design.cutPower?.potencia_kwh, 2);
    } if (calculationsData?.design?.cutPower?.potencia_kwh > calculationsData?.design?.engravePower?.potencia_kwh) {
      return toInteger(calculationsData.design.cutPower?.potencia_kwh, 2);
    }
    return toInteger(calculationsData.design.engravePower?.potencia_kwh, 2);
  };

  const getElectricIntensity = () => {
    if (calculationsData?.design?.typeOfWork === 'cut-or-engrave') {
      return toInteger(calculationsData.design.cutPower?.corriente_maxima, 2);
    } if (calculationsData?.design?.cutPower?.corriente_maxima
      > calculationsData?.design?.engravePower?.corriente_maxima) {
      return toInteger(calculationsData.design.cutPower?.corriente_maxima, 2);
    }
    return toInteger(calculationsData.design.engravePower?.corriente_maxima, 2);
  };

  const handlePDF = async () => {
    if (!isPdfForClient
      && calculationsData.save_quotations
      && selectCategoryValue.selectedOption === 'Agregar Categoria'
      && !clientData.isValidCategoryName) {
      return toaster.danger('Datos invalidos', {
        id: 'forbidden-action',
        duration: 1.5,
      });
    }
    if (isPdfForClient
      && calculationsData.save_quotations
      && selectValue.selectedOption === 'Nuevo cliente'
      && !clientData.isValidClient) {
      return toaster.danger('Datos invalidos', {
        id: 'forbidden-action',
        duration: 1.5,
      });
    }
    setIsLoading(true);
    if (isPdfForClient) {
      const uploadedImage = document.getElementById('upload-files')?.files;
      let companyLogo = null;
      let imageData = null;

      // si ya existen archivos los convierte en base64 para enviarlos junto con los nuevos
      if (uploadedImage?.length > 0) {
        /* eslint no-await-in-loop: "off" */
        const fileDataBase64 = (await convertBase64(uploadedImage[0])).split('base64,')[1];

        // se guardan los archivos en un array de archivos si devuelve la funcion un base64 valido
        imageData = {
          img: {
            base64: fileDataBase64,
            filename: uploadedImage[0].name,
            type: 'image/x-png',
          },
        };
        // convierte el base64 a una url S3
        const imageURL = await uploadImage.imageToS3(imageData);
        companyLogo = (imageURL?.url || null);
      }

      const data = {
        quotationName: calculationsData.save_quotations ? clientData.quotationName : 'Cotizacion',
        client: selectValue.selectedOption === 'Nuevo cliente' ? clientData.client : selectValue.selectedOption,
        companyName: clientData.companyName,
        qty: clientData.qty,
        validez: clientData.validez,
        companyLogo,
        imgDesign: calculationsData.imgDesign?.url || null,
        typeMaterial: calculationsData.material.values.map((item) => ` ${item.name}`),
        designWidth: toInteger(calculationsData.design.designWidth),
        designLarge: toInteger(calculationsData.design.designLength),
        pricePerDesign: toInteger(calculationsData.price?.salePricePerDesign),
        currency: calculationsData.currentCurrency?.currencyCode,
        maxCurrent: toInteger(getElectricIntensity(), 2),
        power: toInteger(getMaxPower(), 2),
        costPerPiece: toInteger(calculationsData.design?.costPerDesign, 2),
        costElectricity: toInteger(calculationsData.electricity?.electricityCostPerDesign, 2),
        costOperator: toInteger(calculationsData.worker?.productionCostPerDesign, 2),
        costTotalPerPiece: toInteger(calculationsData.price?.designFullCost, 2),
        utilityPerPiece: toInteger(calculationsData.price?.profitInCurrency, 2),
        piecesToSell: Math.ceil(calculationsData.machine.shopifyPrice / calculationsData.price.profitInCurrency),
        machine: calculationsData.machine.name,
        powerMachine: (calculationsData.design?.cutPower?.porcentaje_trabajo || 0)
          >= (calculationsData.design?.engravePower?.porcentaje_trabajo || 0)
          ? toInteger(calculationsData.design.cutPower.porcentaje_trabajo, 2)
          : toInteger(calculationsData.design.engravePower.porcentaje_trabajo, 2),
        timePerDesign: toInteger((calculationsData?.design?.engraveWorkTime || 0)
        + (calculationsData?.design?.cutWorkTime || 0)),
        rateElectricity: toInteger(99, 2),
        typeRateElectricity: toInteger(99, 2),
        fixedCostElectricity: toInteger(99, 2),
        rate_type: 'DAC', // DAC, Sur y Peninsular
        electricity_Rate: calculationsData?.electricity_Rate,
        expense_Details: calculationsData?.expense_Details,
        investment_Details: calculationsData?.investment_Details,
      };
      if (calculationsData.save_quotations) {
        if (selectValue.selectedOption === 'Nuevo cliente') {
          const newClient = await Client.create(data, userId);
          if (!newClient?.client?.id) {
            toaster.danger('No se pudo crea el cliente, ni cotizacion', {
              id: 'forbidden-action',
              duration: 1.5,
            });
            return setIsLoading(false);
          }
          const PDF = await Quotations.existingClient.create(data, userId, newClient.client.id);
          setBase64(PDF);
          setCount(count + 1);
        } else {
          const PDF = await Quotations.existingClient.create(data, userId, selectValue.id);
          setBase64(PDF);
        }
      } else {
        const PDF = await Pdf.createClientPDF(data);
        setBase64(PDF);
      }
    } else {
      const data = {
        maxCurrent: toInteger(getElectricIntensity(), 2),
        power: toInteger(getMaxPower(), 2),
        costPerPiece: toInteger(calculationsData.design?.costPerDesign, 2),
        costElectricity: toInteger(calculationsData.electricity?.electricityCostPerDesign, 2),
        costOperator: toInteger(calculationsData.worker?.productionCostPerDesign, 2),
        costTotalPerPiece: toInteger(calculationsData.price?.designFullCost, 2),
        utilityPerPiece: toInteger(calculationsData.price?.profitInCurrency, 2),
        piecesToSell: Math.ceil(calculationsData.machine.shopifyPrice / calculationsData.price.profitInCurrency),
        imgDesign: calculationsData.imgDesign?.url || null,
        machine: calculationsData.machine.name,
        powerMachine: (calculationsData.design?.cutPower?.porcentaje_trabajo || 0)
          >= (calculationsData.design?.engravePower?.porcentaje_trabajo || 0)
          ? toInteger(calculationsData.design.cutPower.porcentaje_trabajo, 2)
          : toInteger(calculationsData.design.engravePower.porcentaje_trabajo, 2),
        typeMaterial: calculationsData.material.values.map((item) => ` ${item.name}`),
        designWidth: toInteger(calculationsData.design.designWidth),
        designLarge: toInteger(calculationsData.design.designLength),
        timePerDesign: toInteger((calculationsData?.design?.engraveWorkTime || 0)
        + (calculationsData?.design?.cutWorkTime || 0)),
        pricePerDesign: toInteger(calculationsData.price?.salePricePerDesign, 2),
        rateElectricity: toInteger(99, 2),
        typeRateElectricity: toInteger(99, 2),
        fixedCostElectricity: toInteger(99, 2),
        rate_type: 'DAC', // DAC, Sur y Peninsular
        electricity_Rate: calculationsData?.electricity_Rate,
        expense_Details: calculationsData?.expense_Details,
        investment_Details: calculationsData?.investment_Details,
        currency: calculationsData.currentCurrency?.currencyCode,
        quotationName: calculationsData.save_quotations ? clientData.quotationName : 'Cotizacion',
        category: selectCategoryValue.selectedOption === 'Agregar Categoria' ? clientData?.categoryName
          : (selectCategoryValue?.selectedOption || ''),
      };

      if (calculationsData.save_quotations) {
        if (selectCategoryValue.selectedOption === 'Agregar Categoria') {
          const newCategory = await Categories.createCategoryByUser({ name: clientData.categoryName }, userId);
          if (!newCategory?.id) {
            toaster.danger(`No se pudo crear la categoria,${newCategory?.message || ''}`, {
              id: 'forbidden-action',
              duration: 1.5,
            });
            return setIsLoading(false);
          }
          const PDF = await Quotations.user.create(data, userId);
          setBase64(PDF);
          setCount(count + 1);
        } else {
          const PDF = await Quotations.user.create(data, userId);
          setBase64(PDF);
        }
      } else {
        const PDF = await Pdf.createUserPDF(data);
        setBase64(PDF);
      }
    }
    return setIsLoading(false);
  };

  const handleClick = () => {
    const modalWidth = (window.outerWidth < 501 ? 250 : 300);
    const asideWidth = document.querySelector('aside')
      ? (modalWidth - document.querySelector('aside').offsetWidth) / 2
      : (modalWidth / 2);
    printCard.current?.classList.add('show-download-pdf-modal');
    printCard.current.style.right = `calc(50% + ${asideWidth}px)`;
    document.getElementsByClassName('main-container')[0].style.opacity = '.3';
    document.querySelector('[data-testid="LocalPrintshopIcon"]').style.color = 'red';
  };

  const handleClickOutSide = (e) => {
    // if (printCard.current.style.display !== 'block') return;
    if (!printCard.current.contains(e.target) && e.target.id !== 'download-pdf') {
      printCard.current?.classList.remove('show-download-pdf-modal');
      document.getElementsByClassName('main-container')[0].style.opacity = '1';
    }
  };

  useEffect(async () => {
    if (!base64?.pdf_base64 && !base64?.pdf_url) return;
    if (calculationsData.save_quotations) {
      window.open(base64?.pdf_url, '_blank');
      return;
    }
    // es necesario convertir el base64 a url tipo blob para descargarlo con window.open
    const base64response = await fetch(`data:application/pdf;base64,${base64.pdf_base64}`);
    const blob = await base64response.blob();
    const url = URL.createObjectURL(blob);
    // abre el archivo tipo blob url en una ventana nueva
    window.open(url, '_blank');
  }, [base64]);

  useEffect(() => {
    const power = getMaxPower();
    const intensity = getElectricIntensity();
    setMachineData({ maxPower: power, electricIntensity: intensity });
  }, []);

  useEffect(async () => {
    const user = await Users.getUser(userId);
    const categories = await Categories.getCategoriesByUser(userId);
    setUserData({ ...user, categories, isLoadingData: false });
  }, [count]);

  return (
    <>
      <div style={{ display: 'none' }} ref={printCard}>
        <div style={{ position: 'relative' }}>
          <div className="download-modal-container item-container">
            {/* <div
              style={{
                borderRight: '10px solid #757575',
                borderLeft: '10px solid transparent',
                borderBottom: '10px solid transparent',
                position: 'absolute',
                transform: 'rotate(135deg)',
                top: 'calc(100% - 8px)',
                right: '45%',
              }}
            /> */}
            <div style={{ display: 'flex' }}>
              <button
                style={{ marginRight: '20px' }}
                type="button"
                className={isPdfForClient ? 'primary-button' : 'secondary-button'}
                onClick={() => setIsPdfForClient(true)}
              >
                Cliente
              </button>
              <button
                type="button"
                className={isPdfForClient ? 'secondary-button' : 'primary-button'}
                onClick={() => setIsPdfForClient(false)}
              >
                Usuario
              </button>
            </div>

            {isPdfForClient
              ? (
                <form style={{ marginTop: '20px' }} onSubmit={(e) => { e.preventDefault(); handlePDF(); }}>
                  <SelectFilter
                    array={userData.clients}
                    placeholderInput="Selecciona un cliente"
                    placeholderFilter="Busca un cliente"
                    listTitle="Clientes :"
                    addNewElement="Nuevo cliente"
                    propertyShown="client"
                    selectValue={selectValue}
                    setSelectValue={setSelectValue}
                    loading={userData.isLoadingData}
                    required
                  />
                  {selectValue?.selectedOption === 'Nuevo cliente' && (
                  <>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Nombre de tu cliente:
                      <span style={{ color: 'red' }}>*</span>
                    </p>
                    <input
                      placeholder="cliente"
                      className="select"
                      value={clientData.client}
                      onChange={(e) => setClientData((prevState) => ({
                        ...prevState,
                        client: e.target.value,
                        isValidClient: !(/[+#%&?=]/).test(e.target.value),
                      }))}
                      required
                      maxLength="35"
                    />
                    <div style={{ display: 'flex', alignItems: 'baseline' }}>
                      {(!clientData?.client)
                        && (
                        <div
                          style={{
                            width: '10px',
                            height: '10px',
                            backgroundColor: '#b1b1b1',
                            borderRadius: '50%',
                            marginRight: '10px',
                          }}
                        />
                        )}
                      {(clientData?.client && clientData.isValidClient === true)
                        && (
                        <Check className="appear" sx={{ color: 'green', fontSize: '15px', marginRight: '5px' }} />
                        )}
                      {(clientData?.client && clientData.isValidClient === false)
                        && (
                        <Clear className="appear" sx={{ color: 'red', fontSize: '15px', marginRight: '5px' }} />
                        )}
                      <p
                        style={{
                          borderRadius: '5px', margin: '10px 0 0 0', fontSize: '12px', color: 'gray',
                        }}
                      >
                        Simbolos no permitidos: &quot; + # % & ? = &quot;
                      </p>
                    </div>
                  </>
                  )}
                  <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                    Nombre de tu Empresa:
                  </p>
                  <input
                    placeholder="Sagaon"
                    className="select"
                    value={clientData.companyName}
                    onChange={(e) => setClientData((prevState) => ({
                      ...prevState,
                      companyName: e.target.value,
                    }))}
                    maxLength="18"
                  />
                  <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                    Numero de diseños que va a cotizar:
                    <span style={{ color: 'red' }}> *</span>
                  </p>
                  <input
                    placeholder="2"
                    className="select"
                    type="number"
                    value={clientData.qty}
                    onChange={(e) => setClientData((prevState) => ({
                      ...prevState,
                      qty: e.target.value,
                    }))}
                    required
                    maxLength="4"
                  />
                  <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                    Duracion de validez:
                    <span style={{ color: 'red' }}> *</span>
                  </p>
                  <input
                    placeholder="5 dias"
                    className="select"
                    value={clientData.validez}
                    onChange={(e) => setClientData((prevState) => ({
                      ...prevState,
                      validez: e.target.value,
                    }))}
                    required
                    maxLength="35"
                  />
                  <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                    Sube un logo de tu empresa:
                  </p>
                  <input id="upload-files" type="file" accept="image/*" />
                  <div className="align-baseline" style={{ justifyContent: 'space-between' }}>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Guardar cotizacion:
                    </p>
                    <input
                      type="checkbox"
                      disabled={isLoading}
                      style={{ height: '15px', width: '15px', marginLeft: '10px' }}
                      defaultChecked={calculationsData.save_quotations}
                      onClick={(e) => setCalculationsData({
                        ...calculationsData,
                        save_quotations: e.target.checked,
                      })}
                    />
                  </div>
                  {calculationsData.save_quotations && (
                  <>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Nombre de la cotizacion:
                      <span style={{ color: 'red' }}> *</span>
                    </p>
                    <input
                      placeholder="Cotizacion 1"
                      className="select"
                      value={clientData.quotationName}
                      onChange={(e) => setClientData((prevState) => ({
                        ...prevState,
                        quotationName: e.target.value,
                      }))}
                      required
                      maxLength="50"
                    />
                  </>
                  )}
                  <button
                    disabled={isLoading}
                    style={{ margin: '20px auto 0 auto' }}
                    className="simple-button submit-pdf-button"
                    type="submit"
                  >
                    Descargar
                  </button>
                </form>
              )
              : (
                <form onSubmit={(e) => { e.preventDefault(); handlePDF(); }}>
                  <Divider style={{ margin: '20px 0 0 0' }} label="Mostrar / Ocultar apartados" textColor="green" />
                  <div className="align-baseline" style={{ justifyContent: 'space-between' }}>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Mostrar Consumo electrico:
                    </p>
                    <input
                      type="checkbox"
                      style={{ height: '15px', width: '15px', marginLeft: '10px' }}
                      defaultChecked={calculationsData.electricity_Rate}
                      onClick={(e) => setCalculationsData({
                        ...calculationsData,
                        electricity_Rate: e.target.checked,
                      })}
                    />
                  </div>
                  <div className="align-baseline" style={{ justifyContent: 'space-between' }}>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Mostrar detalle de costos por diseño:
                    </p>
                    <input
                      type="checkbox"
                      style={{ height: '15px', width: '15px', marginLeft: '10px' }}
                      defaultChecked={calculationsData.expense_Details}
                      onClick={(e) => setCalculationsData({
                        ...calculationsData,
                        expense_Details: e.target.checked,
                      })}
                    />
                  </div>
                  <div className="align-baseline" style={{ justifyContent: 'space-between' }}>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Mostrar retorno de inversion:
                    </p>
                    <input
                      type="checkbox"
                      style={{ height: '15px', width: '15px', marginLeft: '10px' }}
                      defaultChecked={calculationsData.investment_Details}
                      onClick={(e) => setCalculationsData({
                        ...calculationsData,
                        investment_Details: e.target.checked,
                      })}
                    />
                  </div>
                  <Divider style={{ margin: '20px 0 0 0' }} label="" textColor="green" />
                  <div className="align-baseline" style={{ justifyContent: 'space-between', marginBottom: '20px' }}>
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Guardar cotizacion:
                    </p>
                    <input
                      type="checkbox"
                      disabled={isLoading}
                      style={{ height: '15px', width: '15px', marginLeft: '10px' }}
                      defaultChecked={calculationsData.save_quotations}
                      onClick={(e) => setCalculationsData({
                        ...calculationsData,
                        save_quotations: e.target.checked,
                      })}
                    />
                  </div>
                  {calculationsData.save_quotations && (
                  <>
                    <SelectFilter
                      array={userData.categories}
                      placeholderInput="Selecciona una categoria"
                      placeholderFilter="Busca una categoria"
                      listTitle="Categorias :"
                      addNewElement="Agregar Categoria"
                      propertyShown="category_name"
                      selectValue={selectCategoryValue}
                      setSelectValue={setSelectCategoryValue}
                      loading={userData.isLoadingData}
                      required
                    />
                    {selectCategoryValue?.selectedOption === 'Agregar Categoria' && (
                    <>
                      <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                        Nombre de la nueva categoria:
                        <span style={{ color: 'red' }}>*</span>
                      </p>
                      <input
                        placeholder="CNC laser"
                        className="select"
                        value={clientData?.categoryName || ''}
                        onChange={(e) => {
                          setClientData((prevState) => ({
                            ...prevState,
                            categoryName: e.target.value,
                            isValidCategoryName: !(/[+#%&?=]/).test(e.target.value),
                          }));
                        }}
                        required
                        maxLength="35"
                      />
                      <div style={{ display: 'flex', alignItems: 'baseline' }}>
                        {(!clientData?.categoryName)
                          && (
                          <div
                            style={{
                              width: '10px',
                              height: '10px',
                              backgroundColor: '#b1b1b1',
                              borderRadius: '50%',
                              marginRight: '10px',
                            }}
                          />
                          )}
                        {(clientData?.categoryName && clientData.isValidCategoryName === true)
                          && (
                          <Check className="appear" sx={{ color: 'green', fontSize: '15px', marginRight: '5px' }} />
                          )}
                        {(clientData?.categoryName && clientData.isValidCategoryName === false)
                          && (
                          <Clear className="appear" sx={{ color: 'red', fontSize: '15px', marginRight: '5px' }} />
                          )}
                        <p
                          style={{
                            borderRadius: '5px', margin: '10px 0 0 0', fontSize: '12px', color: 'gray',
                          }}
                        >
                          Simbolos no permitidos: &quot; + # % & ? = &quot;
                        </p>
                      </div>
                    </>
                    )}
                    <p style={{ marginBottom: '0', fontSize: '14px', fontStyle: 'italic' }}>
                      Nombre de la cotizacion:
                      <span style={{ color: 'red' }}> *</span>
                    </p>
                    <input
                      placeholder="Cotizacion 1"
                      className="select"
                      value={clientData.quotationName}
                      onChange={(e) => setClientData((prevState) => ({
                        ...prevState,
                        quotationName: e.target.value,
                      }))}
                      required
                      maxLength="50"
                    />
                  </>
                  )}
                  <button
                    disabled={isLoading}
                    style={{ margin: '20px auto 0 auto' }}
                    className="simple-button submit-pdf-button"
                    type="submit"
                  >
                    Descargar
                  </button>
                </form>
              )}
          </div>
        </div>
      </div>

      <div
        role="presentation"
        className="main-container"
        style={{ position: 'relative' }}
        onClick={(e) => handleClickOutSide(e)}
      >

        <button
          onClick={() => setView(view - 1)}
          id="button"
          className="simple-button"
          type="button"
          style={{ position: 'absolute', top: '0', left: '0' }}
        >
          <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />
          Paso anterior
        </button>
        <button
          disabled={isLoading}
          onClick={() => {
            setView(1);
            setMaxView(1);
            setCalculationsData(initialState.calculationsData);
          }}
          id="button"
          className="simple-button"
          type="button"
          style={{ position: 'absolute', top: '0', right: '0' }}
        >
          <RestartAlt />
          Volver a empezar
        </button>

        <div className="appear item-container aligned-items justify-items column">
          <p>RESULTADOS</p>
          <Divider label="Datos de la Maquina" />
          <div className="flex-styles">
            <p>Maquina</p>
            <p>{calculationsData.machine?.name}</p>
          </div>
          <div className="flex-styles">
            <p>Corriente Maxima</p>
            <p>
              {machineData.electricIntensity}
              KWh
            </p>
          </div>
          <Divider lineColor="rgb(231 231 231)" />
          <div className="flex-styles">
            <p>Potencia Maxima</p>
            <p>
              {machineData.maxPower}
              A
            </p>
          </div>
          <Divider label="Detalle de costos por diseño" />
          <div className="flex-styles">
            <p><strong>Concepto</strong></p>
            <p>
              <strong>
                Costo (
                {calculationsData.currentCurrency.currencyCode}
                )
              </strong>
            </p>
          </div>
          <div className="flex-styles">
            <p>Costo del material utilizado</p>
            <p>
              {calculationsData.currentCurrency.symbol}
              {toInteger(calculationsData.design?.costPerDesign, 2)}
            </p>
          </div>
          <Divider lineColor="rgb(231 231 231)" />
          <div className="flex-styles">
            <p>Costo de electricidad aprox.</p>
            <p>
              {calculationsData.currentCurrency.symbol}
              {toInteger(calculationsData.electricity?.electricityCostPerDesign, 2)}
            </p>
          </div>
          <Divider lineColor="rgb(231 231 231)" />
          <div className="flex-styles">
            <p>Costo de operacion</p>
            <p>
              {calculationsData.currentCurrency.symbol}
              {toInteger(calculationsData.worker?.productionCostPerDesign, 2)}
            </p>
          </div>
          <Divider lineColor="rgb(231 231 231)" />
          <div className="flex-styles">
            <p>Costo total del diseño</p>
            <p>
              {calculationsData.currentCurrency.symbol}
              {toInteger(calculationsData.price?.designFullCost, 2)}
            </p>
          </div>
          <Divider label="Retorno de inversion" textColor="green" />
          <div className="flex-styles">
            <p>Precio de venta por diseño</p>
            <p>
              {calculationsData.currentCurrency.symbol}
              {toInteger(calculationsData.price?.salePricePerDesign, 2)}
            </p>
          </div>
          <Divider lineColor="rgb(231 231 231)" />
          <div className="flex-styles">
            <p>Utilidad por diseño</p>
            <p>
              {calculationsData.currentCurrency.symbol}
              {toInteger(calculationsData.price?.profitInCurrency, 2)}
            </p>
          </div>
          {/* {calculationsData.material?.values?.length < 2
          && (
          <>
            <Divider lineColor="rgb(231 231 231)" />
            <div className="flex-styles">
              <p>Utilidad total de una hoja completa</p>
              <p>
                {calculationsData.currentCurrency.symbol}
                {toInteger(calculationsData.price.profitInCurrency
                * calculationsData.design.designsPerPiece
                * calculationsData.material.totalPiecesPerSheet, 2)}
              </p>
            </div>
          </>
          )} */}
          <Divider lineColor="rgb(231 231 231)" />
          <div className="flex-styles">
            <p><strong>Piezas a vender para recuperar la inversion del equipo</strong></p>
            <p>
              <strong>
                {Math.ceil(calculationsData.machine.shopifyPrice / calculationsData.price.profitInCurrency)}
                pzas
              </strong>
            </p>
          </div>

          <button
            disabled={isLoading}
            onClick={() => handleClick()}
            id="download-pdf"
            className="simple-button"
            type="button"
          >
            <LocalPrintshop />
            Descargar PDF
          </button>
        </div>
      </div>
    </>
  );
};

SelectResultsView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    currentCurrency: PropTypes.shape({
      currency: PropTypes.string,
      currencyCode: PropTypes.string,
      country: PropTypes.string,
      symbol: PropTypes.string,
    }),
    machine: PropTypes.shape({
      shopifyPrice: PropTypes.number,
      name: PropTypes.string,
    }),
    electricity: PropTypes.shape({
      electricityCostPerDesign: PropTypes.number,
    }),
    worker: PropTypes.shape({
      productionCostPerDesign: PropTypes.number,
    }),
    design: PropTypes.shape({
      typeOfWork: PropTypes.string,
      costPerDesign: PropTypes.number,
      designsPerPiece: PropTypes.number,
      cutWorkTime: PropTypes.number,
      engraveWorkTime: PropTypes.number,
      designLength: PropTypes.number,
      designWidth: PropTypes.number,
      cutPower: PropTypes.shape({
        porcentaje_trabajo: PropTypes.number,
        potencia_kwh: PropTypes.number,
        corriente_maxima: PropTypes.number,
      }),
      engravePower: PropTypes.shape({
        porcentaje_trabajo: PropTypes.number,
        potencia_kwh: PropTypes.number,
        corriente_maxima: PropTypes.number,
      }),
    }),
    material: PropTypes.shape({
      totalPiecesPerSheet: PropTypes.number,
      materialName: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.shape({
        isUsingSavedMaterial: PropTypes.bool,
        name: PropTypes.string,
        cost: PropTypes.number,
        width: PropTypes.number,
        length: PropTypes.number,
        thickness: PropTypes.number,
      })),
    }),
    price: PropTypes.shape({
      designFullCost: PropTypes.number,
      profitInCurrency: PropTypes.number,
      salePricePerDesign: PropTypes.number,
    }),
    electricity_Rate: PropTypes.bool,
    expense_Details: PropTypes.bool,
    investment_Details: PropTypes.bool,
    save_quotations: PropTypes.bool,
    imgDesign: PropTypes.string,
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
  setMaxView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
  setMaxView: (values) => dispatch({
    type: 'SET_MAX_VIEW',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectResultsView);
